export const APP_ALERT_LANDING_COUNTS = 'APP_ALERT_LANDING_COUNTS';
export const APP_ALERT_ALERTS_SET = 'ALERT_ALERTS/SET';
export const APP_ALERT_CUSTOM_SET = 'ALERT_CUSTOM/SET';
export const APP_ALERT_SUBSCRIPTIONS_SET = 'ALERT_SUBSCRIPTIONS/SET';
export const APP_ALERT_CLIENTS_SET = 'ALERT_CLIENTS/SET';
export const APP_ALERT_PROGRAMS_SET = 'ALERT_PROGRAMS/SET';
export const APP_ALERT_PROJECTS_SET = 'ALERT_PROJECTS/SET';
export const APP_ALERT_SITES_SET = 'ALERT_SITES/SET';
export const APP_ALERT_TEAMNAME_SET = 'ALERT_SELECTEDTEAM/SET';
export const APP_ALERT_DATERANGE_SET = 'ALERT_DATERANGE/SET';
export const APP_ALERT_DATERANGEPICKER_SET = 'ALERT_DATERANGEPICKER/SET';
export const APP_ALERT_SEARCH_FOR_SUBSCRIBE_SET = 'ALERT_SEARCH_FOR_SUBSCRIBE/SET';
export const APP_ALERT_SUBSCRIPTION_INSERT_SUCCESS = 'ALERT_SUBSCRIPTION_INSERT/SUCCESS';
export const APP_ALERT_SUBSCRIPTION_DELETE_SUCCESS = 'ALERT_SUBSCRIPTION_DELETE/SUCCESS';
export const SECURITY_USERS_SET = 'SECURITY_USERS/SET';
export const AAD_LOGIN_SUCCESS = 'AAD_LOGIN/SUCCESS';
export const AAD_LOGOUT_SUCCESS = 'AAD_LOGOUT/SUCCESS';
export const REDUX_RESET = 'REDUX/RESET';
export const SECURITY_IMPERSONATE_FETCH = 'SECURITY_IMPERSONATE/FETCH';
export const ALERT_TYPE = 'ALERT_TYPE';
